import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent {
  @Input() isMobileOpen = false;
  @Output() menuSizeChanged = new EventEmitter<boolean>();
  @Output() mobileMenuClosed = new EventEmitter<void>();

  public isMinimized = false;
  public isMobileViewport = false;

  constructor() {
    this.syncViewport();
  }

  public toggleMenu(): void {
    this.isMinimized = !this.isMinimized;
    this.menuSizeChanged.emit(this.isMinimized);
  }

  public closeMobileMenu(): void {
    this.mobileMenuClosed.emit();
  }

  public onNavItemSelected(): void {
    if (this.isMobileViewport) {
      this.mobileMenuClosed.emit();
    }
  }

  @HostListener('window:resize')
  public onResize(): void {
    this.syncViewport();
  }

  private syncViewport(): void {
    this.isMobileViewport =
      typeof window !== 'undefined' && window.innerWidth < 768;
  }
}
